import { render, staticRenderFns } from "./CreateOrUpdateScheduledNotificationModal.vue?vue&type=template&id=503ea05f&scoped=true"
import script from "./CreateOrUpdateScheduledNotificationModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateScheduledNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ea05f",
  null
  
)

export default component.exports